import React from "react";

/**
 * The one section header used across the site: a mono index, the title, and a
 * hairline that runs out to the edge of the measure.
 */
export default function SectionHeading({ index, title }) {
    return (
        <div className="mb-10 flex items-baseline gap-3 sm:gap-4 md:mb-16">
            <h2 className="flex items-baseline gap-3 whitespace-nowrap text-heading font-semibold text-ink">
                <span className="eyebrow relative -top-1 tracking-[0.2em]">
                    {index}
                </span>
                {title}
            </h2>
            <span
                aria-hidden="true"
                className="h-px flex-1 self-center bg-line"
            />
        </div>
    );
}
